import axios from 'axios';

const getAllVariants = async (token) => {
  try {
    const res = await axios.get('/variants', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getAllVariants;
